export default __webpack_public_path__ + "static/media/pay-crypto.504449bd.svg";